export const API_CONFIG = {
  DEEPSEEK_API_KEY: 'sk-6ad5e734571b4ae38f5e67cc1cfa45ca',
  DEEPSEEK_API_URL: 'https://api.deepseek.com/v1/chat/completions',
  MODEL: 'deepseek-chat'
} 